import { Translations } from "../../../Translations/Translations";
import { Preset } from "./Preset";


export class PresetsStorage
{
    private readonly KEY = "camera-settings-presets";

    constructor(private _lang: Translations) 
    { }

    public LoadAll(): Preset[]
    {
        const presetsAsString = window.localStorage.getItem(this.KEY) ?? "[]";
        const presets = JSON.parse(presetsAsString);

        if (presets.length > 0)
        {
            return presets;
        }

        return this.DefaultPresets;
    }

    private get DefaultPresets(): Preset[]
    {
        return [
            new Preset("low", "400 × 300 px", 400, 300, 50, 0, 0),
            new Preset("optimal", "1200 × 900 px", 1200, 900, 50, 0, 0),
            new Preset("optimal+", "1200 × 900 px 💡", 1200, 900, 70, 90, 0),
            new Preset("high", "1600 × 1200 px", 1600, 1200, 60, 80, 0),
            new Preset("high+", "1600 × 1200 px 💡", 1600, 1200, 70, 90, 0),
            new Preset("max", "2592 × 1944 px", 2592, 1944, 65, 85, 0),
            new Preset("custom1", this._lang.Custom + " #1", 1400, 1100, 55, 75, 0),
            new Preset("custom2", this._lang.Custom + " #2", 1500, 1200, 58, 70, 0),
            new Preset("custom3", this._lang.Custom + " #3", 1600, 1300, 60, 80, 0),
        ];
    }

    public Update(presets: Preset[]): void
    {
        window.localStorage.setItem(this.KEY, JSON.stringify(presets));
    }
}
